import { SuggestedApp } from '../../models/app';
import styles from '../Header/styles.module.scss';
import defaultImg from '../../assets/icon_not_loading.png';
import React from 'react';
import { getLocalizedSuggestedApp } from 'component-helpers/app-details';
import i18n from 'i18next';

export const RenderSearchItem = (app : SuggestedApp):JSX.Element =>{
  const {
    name,
    filenameIconSmall
  } =  getLocalizedSuggestedApp(app, i18n.language);
  return (
    <div className={styles.listItem}>
      <img
        src={filenameIconSmall}
        alt={name}
        onError={(evt) => (evt.currentTarget.src = defaultImg)}
      />
      <span>{name}</span>
    </div>
  );
}
